import { render } from "./EtatProduitsRupturePage.vue?vue&type=template&id=be6b7996&ts=true"
import script from "./EtatProduitsRupturePage.vue?vue&type=script&lang=ts"
export * from "./EtatProduitsRupturePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__